import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { initSliders } from '../../../../../dc-slider.js';

const responsiveElements = require('../../../../../../responsive-elements.js');
const toggleContents = require('../../../../../../toggle-contents');

class Banner extends PureComponent {
  componentDidMount() {
    responsiveElements.initResponsiveImages();
    toggleContents.toggleContents('.toggleControler');
    initSliders();
  }

  render() {
    return (
      <div className={'row'}>
        <div className={'col-12'} dangerouslySetInnerHTML={{ __html: this.props.htmlContent }} />
      </div>
    );
  }
}

Banner.displayName = 'Banner';

Banner.propTypes = {
  htmlContent: PropTypes.string.isRequired
};

export default Banner;
